import { render, staticRenderFns } from "./MaterialListFooter.vue?vue&type=template&id=0bcbaf4c&"
import script from "./MaterialListFooter.vue?vue&type=script&lang=js&"
export * from "./MaterialListFooter.vue?vue&type=script&lang=js&"
import style0 from "./MaterialListFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports